import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './notifications.magic.css.js';
import script from './notifications.js';

const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition-group',{class:[
        _vm.isMobileApp ? 'notifications-mobile-app' : 'notifications',
        { 'notifications--top-nav': _vm.isTopNavEnabled }
    ],attrs:{"name":"slide-in","tag":"div","part":_vm.$p('notifications', _vm.isTopNavEnabled ? 'notifications--top-nav': '')}},_vm._l((_vm.notifications),function(notification){return _c('magic-ui-notification',{key:notification.id,staticClass:"notification",class:_vm.isToastNotification && notification.style !== 'message' ? 'notification--toast': '',attrs:{"part":_vm.$p('notification', _vm.isToastNotification && notification.style !== 'message' ? 'notification--toast': ''),"dismissible":notification.dismissible,"variant":notification.style,"unique-id":notification.uniqueID,"is-toast-notification":_vm.isToastNotification,"progress-variant":_vm.progressVariant(notification.closeDelay),"label":notification.label,"url":notification.url,"hide-close-icon":notification.hideCloseIcon},domProps:{"content":_vm.interpolate(notification.body)},on:{"close":function($event){return _vm.close(notification)}}})}),1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-84ea21f4_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-84ea21f4";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
